// Constants
import { VALIDATION_CONSTRAINTS } from './validation';

/** Validation error messages */
export const VALIDATION_MESSAGES = {
  employee: {
    name: {
      required: 'Employee name is required',
      tooShort: 'Employee name cannot be empty',
      tooLong: `Employee name must be less than ${VALIDATION_CONSTRAINTS.name.maxLength} characters`,
    },
    avatar: {
      invalidUrl: 'Employee avatar must be a valid URL',
    },
    openingSentence: {
      required: 'Opening sentence is required',
      tooShort: 'Opening sentence cannot be empty',
      tooLong: `Opening sentence must be less than ${VALIDATION_CONSTRAINTS.openingSentence.maxLength} characters`,
      mainText: {
        empty: 'The text cannot be empty',
        required: 'The text is required',
      },
    },
    title: {
      required: 'Job title is required',
      tooShort: `Job title must be at least ${VALIDATION_CONSTRAINTS.title.minLength} characters`,
      tooLong: `Job title must be less than ${VALIDATION_CONSTRAINTS.title.maxLength} characters`,
    },
  },
  year: {
    required: 'Year is required',
    invalid: 'Year must be a valid number',
    outOfRange: `Year must be between ${VALIDATION_CONSTRAINTS.year.min} and ${VALIDATION_CONSTRAINTS.year.max}`,
  },
} as const;
